import React, { useEffect } from 'react';

/**
 * Componente de notificación temporal (toast)
 *
 * @param {Object} props - Propiedades del componente
 * @param {string} props.message - Mensaje a mostrar
 * @param {string} [props.type='info'] - Tipo: 'success' | 'error' | 'warning' | 'info'
 * @param {number} [props.duration=3000] - Duración en ms antes de auto-cerrar
 * @param {Function} props.onClose - Callback al cerrar
 * @returns {JSX.Element}
 */
function Toast({ message, type = 'info', duration = 3000, onClose }) {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose]);

  /**
   * Obtiene clase de ícono FontAwesome según tipo de toast
   * @returns {string} Clase del ícono
   */
  const getIcon = () => {
    switch(type) {
      case 'success':
        return 'fa-check-circle';
      case 'error':
        return 'fa-times-circle';
      case 'warning':
        return 'fa-exclamation-triangle';
      case 'info':
      default:
        return 'fa-info-circle';
    }
  };

  return (
    <div className={`toast toast-${type} toast-show`}>
      <div className="toast-icon">
        <i className={`fas ${getIcon()}`}></i>
      </div>
      <div className="toast-message">{message}</div>
      <button className="toast-close" onClick={onClose}>
        <i className="fas fa-times"></i>
      </button>
    </div>
  );
}

export default Toast;